import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import App from "./App";
import store from "store";
import { appInstance } from "./axios-config";
import * as serviceWorker from "./serviceWorker";
import { logoutUser } from "store/actions";

window.recaptchaOptions = {
  useRecaptchaNet: true
};

const stripePromise = loadStripe(process.env.REACT_APP_STRIP_KEY);

const app = (
  <Provider store={store}>
    <Elements stripe={stripePromise}>
      <Router>
        <App />
      </Router>
    </Elements>
  </Provider>
);

appInstance.interceptors.response.use(
  res => res,
  err => {
    if (err.response && err.response.status === 401)
      store.dispatch(logoutUser(false));
    return err;
  }
);

ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
